/**
 * BNPL allowed characters (ERS-83)
 *
 * The provider (Credi2) rejects billing data that contains characters such as `¡ “ ¶ ¢ [ ] | { } ≠`
 * with a 4xx. It accepts Unicode letters and combining marks, digits, whitespace and the punctuation
 * `. , / - ' ’ ´ ` ^`. The rule is inferred from a single Credi2 test call, not from a provider spec,
 * so it errs permissive and the provider stays the final judge: whatever slips through surfaces on the
 * payment screen (09). The email address has its own, narrower set: letters, digits, whitespace and `@ . _ + -`.
 */

const DISALLOWED_CHARACTER = /[^\p{L}\p{M}0-9\s.,/'’´`^-]/gu;
const DISALLOWED_EMAIL_CHARACTER = /[^\p{L}\p{M}0-9\s@._+-]/gu;

function findUniqueMatches(value: string, pattern: RegExp): string[] {
  return [...new Set(value.match(pattern) ?? [])];
}

/**
 * Characters of a billing field value that the provider would reject.
 *
 * @param {string} value Field value as typed.
 * @return {string[]} Unique offending characters, in input order; empty when the value is acceptable.
 */
export function findDisallowedBnplCharacters(value: string): string[] {
  return findUniqueMatches(value, DISALLOWED_CHARACTER);
}

/**
 * Characters of an email address that the provider would reject.
 *
 * @param {string} value Email address as typed.
 * @return {string[]} Unique offending characters, in input order; empty when the value is acceptable.
 */
export function findDisallowedBnplEmailCharacters(value: string): string[] {
  return findUniqueMatches(value, DISALLOWED_EMAIL_CHARACTER);
}
